function showAlertMessage(message) {
    var alert = $(getAlertMessageTemplate(message)).delay(5000).fadeOut(1500);
    $(".alert-container").append(alert)
}

function getAlertMessageTemplate(message) {
    return '<div id="custom-error-message" class="alert alert-dismissible alert-danger fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<i aria-hidden="true" class="fas fa-times"></i>' +
        '</button>' +
        '<strong>' + message + '</strong>' +
        '</div>';
}

$(function () {
    setTimeout(function () {
        $("div.alert").delay(2000).fadeOut(1500)
    },500)
})

window.showAlertMessage = showAlertMessage;


// WEBPACK FOOTER //
// ./resources/js/components/alerts.js